import { ref } from "vue";
import axios from "axios";

export declare type MapList = {
  id: string;
  name: string;
  identifies: Identify[];
};

export declare type Identify = {
  id: string;
  name: string;
  fields: any;
};

export declare type CartoResource = {
  baseUrl: string;
  vizId: string;
  apiKey?: string;
};

export default function useIdentify() {
  const mapList = ref<MapList[]>([]);
  const loading = ref<boolean>(false);
  const popupExist = ref<boolean>(false);
  const fetchIdentifies = async (
    vizs: CartoResource[],
    lng: number,
    lat: number
  ) => {
    const identifyUrls = vizs.map(
      (viz) =>
        `${viz.baseUrl}/api/v3/viz/${viz.vizId}/identify?lng=${lng}&lat=${lat}&api_key=${viz.apiKey}`
    );
    try {
      loading.value = true;
      const responses = await Promise.all(
        identifyUrls.map((url) => axios.get(url))
      );
      const results = responses
        .map((response) => response.data)
        .filter((r) => r.identifies.length > 0);
      popupExist.value = responses.map((response) => response.data).some((r) => r.hasPopup);
      mapList.value = results;
    } catch (error) {
      console.error("Error fetching identifies:", error);
    } finally {
      loading.value = false;
    }
  };

  return {
    loading,
    mapList,
    popupExist,
    fetchIdentifies,
  };
}
